import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  deviceCtn: {
    "& .MuiFormControl-root": {
      maxWidth: "216px",
    },
  },
  outerLabelContainer: {
    flexBasis: "content",
  },
}));
